import config from "@/config";

import APIClient from "./api-client";

const api = new APIClient({
  baseURL: config.API_URL,
});

export { APIClient, api };
